(function () {
    "use strict";

    angular
        .module("app")
        .directive("linePlanBriefs", linePlanBriefs);

    function linePlanBriefs(LinePlanService) {
        return {
            restrict: "E",
            link: function (scope) {
                scope.loadData = function (id) {
                    //Get Lineplan briefs
                    if (id !== undefined) {
                        //test
                        if (scope.$root.bId) {
                            scope.loadItem = { BriefSeasonalId: null };
                            console.log('brief id found, get one brief');
                            LinePlanService.getBriefInfo(scope.$root.bId).then(function (response) {
                                scope.brief = response;
                                scope.briefs = [response];
                                scope.loadItem.BriefSeasonalId = response.BriefSeasonalId;
                                scope.$root.bName = response.BriefName;
                            });
                        } else {
                            console.log('loading briefs...');
                            LinePlanService.getLinePlanBriefs(id).then(function (data) {
                                if (data) {
                                    scope.briefs = data;
                                }
                            });
                        }
                    }
                }

                scope.loadData(scope.linePlanId);

                scope.$watch("linePlanId", function (newValue, oldValue) {
                    if (newValue !== oldValue)
                        scope.loadData(newValue);
                });

                scope.$watch("updateDirectives", function (newValue) {
                    if (typeof newValue == 'undefined')
                        return;
                    scope.loadData(newValue);
                });

                
            },
            scope: { linePlanId: "=", updateDirectives: "=" },
            templateUrl: templateUrl("app/directives/linePlan/linePlanBriefs.directive.html")
        };
    }
})();
